"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.escapeRegExp = escapeRegExp;
exports.buildNamePattern = buildNamePattern;
exports.patternToValue = patternToValue;
// Admins type plain text ("O'Brien (Jr.)"), never a pattern. Every regex
// metacharacter has to be escaped or the saved rule either fails the backend's
// `new RegExp(v)` check or silently matches the wrong people.
function escapeRegExp(value) {
    return value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
// Whole-word, case-insensitive. The backend matches the stored pattern
// unanchored, so without the boundaries "ben" also matches "Reuben" — the
// admin picks a name and silently widens the rule to everyone containing it.
const WORD_BOUNDARY = "\\b";
function buildNamePattern(value) {
    return `${WORD_BOUNDARY}${escapeRegExp(value.trim())}${WORD_BOUNDARY}`;
}
// Recovers the admin's original text from a stored pattern so edit can
// repopulate the input.
//
// Walked one token at a time rather than stripped with a regex: an escaped
// backslash is "\\\\", so a name ending in one leaves a trailing "b" that a
// naive /\\b$/ would eat as the closing boundary. Patterns stored before the
// boundaries existed have neither, and still read back unchanged.
function patternToValue(pattern) {
    var _a;
    let value = "";
    let index = pattern.startsWith(WORD_BOUNDARY) ? WORD_BOUNDARY.length : 0;
    while (index < pattern.length) {
        if (pattern[index] !== "\\") {
            value += pattern[index];
            index += 1;
            continue;
        }
        const isClosingBoundary = pattern[index + 1] === "b" && index + 2 === pattern.length;
        if (isClosingBoundary)
            break;
        value += (_a = pattern[index + 1]) !== null && _a !== void 0 ? _a : "";
        index += 2;
    }
    return value;
}
